import React, { Component } from "react";
import { Container, Button } from "reactstrap";

class OTP extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleSubmit = () => {
    this.props.SendOTP();
  };

  render() {
    return (
      <Container
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh"
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "50%",
            backgroundColor: "#1768B7"
          }}
        >
          <Button type="submit" onClick={this.handleSubmit}>
            Send OTP
          </Button>
        </div>
      </Container>
    );
  }
}

export default OTP;
